module.exports = __webpack_public_path__ + "img/media_play_small.3a1fcec0.png";